import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useState } from "react";

const OrchestrationRationaleTraceViewer = ({ traces }) => {
  const [copySuccess, setCopySuccess] = useState(null);

  // Extract all rationale and query information from traces in order of appearance
  const traceItems = [];

  traces.forEach((trace) => {
    if (trace.orchestrationTrace) {
      // Track rationales
      if (trace.orchestrationTrace.rationale) {
        const rationaleText = trace.orchestrationTrace.rationale.text;
        traceItems.push({
          type: "rationale",
          text: rationaleText,
        });
      }
      // Track queries from invocationInput
      if (
        trace.orchestrationTrace.invocationInput &&
        trace.orchestrationTrace.invocationInput.actionGroupInvocationInput &&
        trace.orchestrationTrace.invocationInput.actionGroupInvocationInput
          .requestBody &&
        trace.orchestrationTrace.invocationInput.actionGroupInvocationInput
          .requestBody.content
      ) {
        const content =
          trace.orchestrationTrace.invocationInput.actionGroupInvocationInput
            .requestBody.content;

        if (content["application/json"]) {
          const sqlQueryParam = content["application/json"].find(
            (param) => param.name === "SQLQuery"
          );
          if (sqlQueryParam) {
            traceItems.push({
              type: "query",
              text: sqlQueryParam.value,
            });
          }
        }
      }
    }
  });

  const handleCopyClick = (text, index) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopySuccess(index);
        setTimeout(() => setCopySuccess(null), 2000);
      },
      (err) => console.error("Could not copy text: ", err)
    );
  };

  return (
    <Box>
      {traceItems.length > 0 ? (
        traceItems.map((item, index) => (
          <Box key={index} className="trace-item">
            {item.type === "rationale" && (
              <Box className="rationale-section">
                <Typography
                  color="secondary"
                  variant="subtitle1"
                  sx={{ fontWeight: "bold" }}
                  gutterBottom
                >
                  SQL Rationale
                </Typography>
                <ReactMarkdown
                  remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
                >
                  {item.text}
                </ReactMarkdown>
              </Box>
            )}

            {item.type === "query" && (
              <Box className="query-section">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    component="div"
                    color="secondary"
                    variant="subtitle1"
                    sx={{ fontWeight: "bold" }}
                  >
                    SQL Generated
                  </Typography>
                  <Tooltip
                    title={copySuccess === index ? "Copied!" : "Copy SQL"}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleCopyClick(item.text, index)}
                      sx={{
                        color:
                          copySuccess === index
                            ? "success.main"
                            : "action.active",
                        transition: "color 0.2s",
                      }}
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Paper
                  variant="outlined"
                  sx={{
                    mb: 2,
                    p: 1.5,
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                    borderRadius: 3,
                    fontFamily: "monospace",
                    fontSize: "0.85rem",
                    whiteSpace: "pre-wrap",
                    overflowX: "auto",
                  }}
                >
                  {item.text}
                </Paper>
              </Box>
            )}
          </Box>
        ))
      ) : (
        <Typography>No rationale or queries found in the traces.</Typography>
      )}
    </Box>
  );
};

export default OrchestrationRationaleTraceViewer;
